import searchUnFilter from '../../../searchUnFilter';

const RAZZLE_APP_ACCOUNTS = process.env.RAZZLE_APP_ACCOUNTS;

const handlePostLoginRedirect = (postId) => {
    const returnUrl = `/vibe/posts/${postId}${searchUnFilter(document.location.search)}`;
    setTimeout(() => {
        window.location.href = RAZZLE_APP_ACCOUNTS
            + '/endpoint?cache=0&new=true&continue='
            + encodeURIComponent(returnUrl);
    }, 500);
};

export default handlePostLoginRedirect;

